// Config
export const AWS_REGION = process.env.REACT_APP_AWS_REGION;
export const ADMIN_LANDING_PAGE = '/config/agency-settings';
export const AGENCY_LANDING_PAGE = '/analytics/transit-delay';
